/**
* Main store function
*/
import { configureStore as reduxConfitureStore } from '@reduxjs/toolkit';
import rootReducer from './reducers';

let store = null;

export function getStore() {
    return store;
}

export function configureStore(initialState = {}) {
    store = reduxConfitureStore({
        reducer: rootReducer,
        middleware: getDefaultMiddleware => getDefaultMiddleware({ thunk: true, immutableCheck: false, serializableCheck: false }),
        preloadedState: initialState,
        enhancers: getDefaultEnhancers => getDefaultEnhancers(),
      });

      if(process.env.NODE_ENV !== 'production' && module.hot) {
        module.hot.accept('./reducers', () => store.replaceReducer(rootReducer));
      }
      return store;
}
